export default {
  NEW: 'new',
  LOADING: 'loading',
  DONE: 'done',
  FAILED: 'failed',
  ERROR: 'error',
};
